import { render, staticRenderFns } from "./RepeatDetail.vue?vue&type=template&id=3680bdfc&"
import script from "./RepeatDetail.vue?vue&type=script&lang=js&"
export * from "./RepeatDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports